import dayjs from 'dayjs';

export function validateTravelDates(
  checkInDate: string | undefined,
  checkOutDate: string | undefined,
  hasBookedHotel: boolean | undefined
) {
  if (!checkInDate || !checkOutDate) {
    return 'Travel dates are required';
  }
  if ((!hasBookedHotel || !hasBookedHotel == undefined) && dayjs(checkInDate).isBefore(dayjs(), 'day')) {
    return 'Check in date cannot be in the past without a booked hotel';
  }

  if (dayjs(checkOutDate).isBefore(dayjs(checkInDate))) {
    return 'Check in date cannot be before check out date';
  }

  return undefined;
}
